export default __webpack_public_path__ + "static/media/cunningstrike5.9ad9e61c.png";